import { post } from "axios"

const getLogin = (usuario, password) => {   
   return (
      post(`${process.env.REACT_APP_URL_API}login`,
         {
            user: usuario,
            pass: password,
         },
         {
            headers:
            {
               "Content-Type": 'application/x-www-form-urlencoded'
            }
         })
         .then(response => {
            const { data } = response
            return data
         })
         .catch(error => {            
            return error
         })
   )
}
export default getLogin